// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../Assets/images/Intervenants-bg-matching-plat.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section {
  padding: 4% 3%;
  /* display: flex; */
  flex-direction: column;
  align-items: center;
  justify-content: center;

}
.satisfaction-header {
  color: #2E2E2E;
  text-align : right;

}

.custom-rating-container {
  display: inline-block; /* Pour que le conteneur s'adapte à la taille des étoiles */
  position: relative;
  border-radius: 20px;
  background-color: #4AAE9B;
 width: 170px;
  overflow: hidden; /* Pour masquer le contenu qui dépasse les limites du conteneur */
  left :90px;
  margin-bottom: 25px;
}

.custom-rating-container .react-stars-wrapper {
  position: absolute;
  top: 0;
  left: 120px;
}


.cards {
  padding-top: 100px;
}
.card {
  margin-left: auto;
  margin-right: auto;
  border: none !important;
  background-color: white;
  border-radius: 20px;
  /* background: linear-gradient(rgb(255, 255, 255) 73%, rgb(246, 209, 216)); */
  border-radius: 20px !important;
}
.btn_savoir {
  border: 2px solid #4AAE9B !important;
  background-color: #4AAE9B !important;
  color: rgb(255, 255, 255) !important;
  padding: 10px 28px !important;
  font-size: 16px !important;
  font-family: "Lato";
  cursor: pointer !important;
  font-weight: 500;
  border-radius: 30px !important;
  transition: background-color 0.3s ease-in-out;
  margin-top: 10px;
}
.btn-more {
  border: 3px solid #4AAE9B;
/*   background-color: #66534D;
 */  background-color: #4AAE9B;
 color: #ffffff;
  padding: 15px 30px;
  font-size: 20px;
  cursor: pointer;
  border-radius: 40px;
  transition: background-color 0.3s ease-in-out;
}
.btn-more:hover {
  border: 3px solid #A8C9B0;
  background-color: #A8C9B0;
  color: white;
}
.btn-contact {
  border: 3px solid #D6A77A;
/*   background-color: #66534D;
 */  background-color: #D6A77A;
 color: #ffffff;
  padding: 15px 30px;
  font-size: 20px;
  cursor: pointer;
  border-radius: 40px;
  transition: background-color 0.3s ease-in-out;
}
.btn-contact:hover {
  border: 3px solid #C9BAAC;
  background-color: #C9BAAC;
  color: white;
}

.btn_savoir:hover {
  background-color: #A8C9B0 !important;
  color: #ffffff !important;
  border: 2px solid #A8C9B0 !important;
}
.div-more {
  padding-top: 50px;
}
.bg-inter {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}

.slick-arrow {
  display: flex !important;
}
/* Add this to your stylesheet */
.slick-prev,
.slick-next {
  font-size: 0; /* Hide default arrow content */
  width: 40px;
  height: 40px;
  background-color: transparent; /* Pink background */
  color: #D6A77A; /* White arrow color */
  border-radius: 50%; /* Make it a circle */
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  cursor: pointer;
  transition: background-color 0.3s; /* Add transition for hover effect */
  border: 3px solid #D6A77A;
}
.slick-prev:before {
  content: "\\f053"; /* FontAwesome chevron-left icon */
}
.slick-next:before {
  content: "\\f054"; /* FontAwesome chevron-right icon */
}

.slick-next:before {
  content: "\\f054"; /* FontAwesome chevron-right icon */
  font-family: "FontAwesome";
  font-size: 20px;
  font-weight: bold;
  margin: auto;
  position: absolute;
  color: #D6A77A;
}
.slick-prev:before {
  content: "\\f053"; /* FontAwesome chevron-right icon */
  font-family: "FontAwesome";
  font-size: 20px;
  font-weight: bold;
  margin: auto;
  position: absolute;
  color: #D6A77A;
}

.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
    color: #D6A77A;
    outline: none;
    background: #f8e1c2;
}

.slick-prev {
  left: -75px; /* Position the left arrow */
}

.slick-next {
  right: -75px; /* Position the right arrow */
}

/* Add this to your Header.css file */
.slick-slider {
  padding-top: 2%;
  padding-bottom: 2%;
  margin: 0 auto; /* Center the slider */
  max-width: 80%; /* Set the maximum width */
  width: 100%; /* Ensure the slider takes up available space */
  text-align: center;  
}
.star-rating {
  flex-grow: 1;
  text-align: right;
  margin-right: 10px; /* Add some space between the star rating and button */
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 35px;
}
.user-photo{
  width: 75%;
  margin: auto;
  margin-top: 15px;
}
@media (minwidth: 768px) {
  .bg-header-mobile {
    display: none;
  }
}

@media (maxwidth: 768px) {
  .bg-header {
    display: none;
  }
   .bg-inter {
  padding: 100px 30px;
}
  .responsive {
    width: 100%;
    height: auto;
  }
  section {
    align-items: center;
    padding: 50px 30px;
  }
  .cards {
    padding-top: 50px; /* Reduce padding on smaller screens */
  }

  .slick-slider {
    padding-top: 50px; /* Reduce padding on smaller screens */
  }
  .slick-slider .slick-slide {
    margin-right: 20px; /* Adjust this value to control the space between cards */
  }
  .slick-prev,
  .slick-next {
    font-size: 16px; /* Decrease arrow size on smaller screens */
    width: 30px;
    height: 30px;
  }

  .btn,
  .btn-more {
    font-size: 14px; /* Decrease button font size on smaller screens */
    padding: 8px 18px !important;
  }
  .center{
    width: 60% !important;
  }
}
.custom-rating {
  /* Ajoutez vos styles personnalisés ici */
  /* Par exemple */
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.column {
  padding: 10px; /* Optional padding for spacing */
}

.arrowDown{
  animation: MoveUpDown 1s linear infinite;
   position: relative;
   left: 0;
   bottom: 0;
 }

 @media (max-width: 1089px) {
  .arrowDown{
    width: 5% !important;
  }
  .bg-inter {
  padding: 100px 30px;
}
}

@keyframes MoveUpDown {
  0%, 100% {
    bottom: 0;
  }
  50% {
    bottom: 15px;
  }
}

.hover14 {
  position: relative;
  /*display: inline-block;*/ /* Ensures that the hover effect wraps around the image */
}

.hover14::before {
  content: '';
  position: absolute;
  top: 0;
  left: -75%;
  z-index: 2;
  display: block;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 100%);
  transform: skewX(-25deg);
}

.hover14:hover::before {
  animation: shine 0.75s forwards;
}

@keyframes shine {
  100% {
    left: 125%;
  }
}

@media (max-width: 1090px) {
  
  .column {
    flex: 1 1 100%;
    /* text-align: center; */
  }
  .bg-inter {
  padding: 100px 30px;
}
}

/* Responsive for mobile */
@media (max-width: 480px) {
 
  .column {
    flex: 1 1 100%;
    padding: 2% 0; /* Additional padding for mobile */
  }

  .bg-inter {
  padding: 100px 30px;
}

}

`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/Intervenants/IntervenantsHome.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;AAEzB;AACA;EACE,cAAc;EACd,kBAAkB;;AAEpB;;AAEA;EACE,qBAAqB,EAAE,2DAA2D;EAClF,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;CAC1B,YAAY;EACX,gBAAgB,EAAE,iEAAiE;EACnF,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;;AAGA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,6EAA6E;EAC7E,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,8BAA8B;EAC9B,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;EACE,GAAG,yBAAyB;CAC7B,cAAc;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;EACE,GAAG,yBAAyB;CAC7B,cAAc;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yDAAkF;EAClF,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;AACA,gCAAgC;AAChC;;EAEE,YAAY,EAAE,+BAA+B;EAC7C,WAAW;EACX,YAAY;EACZ,6BAA6B,EAAE,oBAAoB;EACnD,cAAc,EAAE,sBAAsB;EACtC,kBAAkB,EAAE,qBAAqB;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,iCAAiC,EAAE,oCAAoC;EACvE,yBAAyB;AAC3B;AACA;EACE,gBAAgB,EAAE,kCAAkC;AACtD;AACA;EACE,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;EACE,gBAAgB,EAAE,mCAAmC;EACrD,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB,EAAE,mCAAmC;EACrD,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;IAII,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;EACE,WAAW,EAAE,4BAA4B;AAC3C;;AAEA;EACE,YAAY,EAAE,6BAA6B;AAC7C;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc,EAAE,sBAAsB;EACtC,cAAc,EAAE,0BAA0B;EAC1C,WAAW,EAAE,+CAA+C;EAC5D,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAE,sDAAsD;AAC5E;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;GACC;EACD,mBAAmB;AACrB;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,iBAAiB,EAAE,sCAAsC;EAC3D;;EAEA;IACE,iBAAiB,EAAE,sCAAsC;EAC3D;EACA;IACE,kBAAkB,EAAE,yDAAyD;EAC/E;EACA;;IAEE,eAAe,EAAE,2CAA2C;IAC5D,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe,EAAE,iDAAiD;IAClE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,iCAAiC;AAClD;;AAEA;EACE,wCAAwC;GACvC,kBAAkB;GAClB,OAAO;GACP,SAAS;CACX;;CAEA;EACC;IACE,oBAAoB;EACtB;EACA;EACA,mBAAmB;AACrB;AACA;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,yDAAyD;AACtF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,cAAc;EACd,UAAU;EACV,YAAY;EACZ,yFAAyF;EACzF,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE;IACE,cAAc;IACd,wBAAwB;EAC1B;EACA;EACA,mBAAmB;AACrB;AACA;;AAEA,0BAA0B;AAC1B;;EAEE;IACE,cAAc;IACd,aAAa,EAAE,kCAAkC;EACnD;;EAEA;EACA,mBAAmB;AACrB;;AAEA","sourcesContent":["section {\n  padding: 4% 3%;\n  /* display: flex; */\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n}\n.satisfaction-header {\n  color: #2E2E2E;\n  text-align : right;\n\n}\n\n.custom-rating-container {\n  display: inline-block; /* Pour que le conteneur s'adapte à la taille des étoiles */\n  position: relative;\n  border-radius: 20px;\n  background-color: #4AAE9B;\n width: 170px;\n  overflow: hidden; /* Pour masquer le contenu qui dépasse les limites du conteneur */\n  left :90px;\n  margin-bottom: 25px;\n}\n\n.custom-rating-container .react-stars-wrapper {\n  position: absolute;\n  top: 0;\n  left: 120px;\n}\n\n\n.cards {\n  padding-top: 100px;\n}\n.card {\n  margin-left: auto;\n  margin-right: auto;\n  border: none !important;\n  background-color: white;\n  border-radius: 20px;\n  /* background: linear-gradient(rgb(255, 255, 255) 73%, rgb(246, 209, 216)); */\n  border-radius: 20px !important;\n}\n.btn_savoir {\n  border: 2px solid #4AAE9B !important;\n  background-color: #4AAE9B !important;\n  color: rgb(255, 255, 255) !important;\n  padding: 10px 28px !important;\n  font-size: 16px !important;\n  font-family: \"Lato\";\n  cursor: pointer !important;\n  font-weight: 500;\n  border-radius: 30px !important;\n  transition: background-color 0.3s ease-in-out;\n  margin-top: 10px;\n}\n.btn-more {\n  border: 3px solid #4AAE9B;\n/*   background-color: #66534D;\n */  background-color: #4AAE9B;\n color: #ffffff;\n  padding: 15px 30px;\n  font-size: 20px;\n  cursor: pointer;\n  border-radius: 40px;\n  transition: background-color 0.3s ease-in-out;\n}\n.btn-more:hover {\n  border: 3px solid #A8C9B0;\n  background-color: #A8C9B0;\n  color: white;\n}\n.btn-contact {\n  border: 3px solid #D6A77A;\n/*   background-color: #66534D;\n */  background-color: #D6A77A;\n color: #ffffff;\n  padding: 15px 30px;\n  font-size: 20px;\n  cursor: pointer;\n  border-radius: 40px;\n  transition: background-color 0.3s ease-in-out;\n}\n.btn-contact:hover {\n  border: 3px solid #C9BAAC;\n  background-color: #C9BAAC;\n  color: white;\n}\n\n.btn_savoir:hover {\n  background-color: #A8C9B0 !important;\n  color: #ffffff !important;\n  border: 2px solid #A8C9B0 !important;\n}\n.div-more {\n  padding-top: 50px;\n}\n.bg-inter {\n  background-image: url(../../../../Assets/images/Intervenants-bg-matching-plat.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.slick-arrow {\n  display: flex !important;\n}\n/* Add this to your stylesheet */\n.slick-prev,\n.slick-next {\n  font-size: 0; /* Hide default arrow content */\n  width: 40px;\n  height: 40px;\n  background-color: transparent; /* Pink background */\n  color: #D6A77A; /* White arrow color */\n  border-radius: 50%; /* Make it a circle */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  cursor: pointer;\n  transition: background-color 0.3s; /* Add transition for hover effect */\n  border: 3px solid #D6A77A;\n}\n.slick-prev:before {\n  content: \"\\f053\"; /* FontAwesome chevron-left icon */\n}\n.slick-next:before {\n  content: \"\\f054\"; /* FontAwesome chevron-right icon */\n}\n\n.slick-next:before {\n  content: \"\\f054\"; /* FontAwesome chevron-right icon */\n  font-family: \"FontAwesome\";\n  font-size: 20px;\n  font-weight: bold;\n  margin: auto;\n  position: absolute;\n  color: #D6A77A;\n}\n.slick-prev:before {\n  content: \"\\f053\"; /* FontAwesome chevron-right icon */\n  font-family: \"FontAwesome\";\n  font-size: 20px;\n  font-weight: bold;\n  margin: auto;\n  position: absolute;\n  color: #D6A77A;\n}\n\n.slick-prev:hover,\n.slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus {\n    color: #D6A77A;\n    outline: none;\n    background: #f8e1c2;\n}\n\n.slick-prev {\n  left: -75px; /* Position the left arrow */\n}\n\n.slick-next {\n  right: -75px; /* Position the right arrow */\n}\n\n/* Add this to your Header.css file */\n.slick-slider {\n  padding-top: 2%;\n  padding-bottom: 2%;\n  margin: 0 auto; /* Center the slider */\n  max-width: 80%; /* Set the maximum width */\n  width: 100%; /* Ensure the slider takes up available space */\n  text-align: center;  \n}\n.star-rating {\n  flex-grow: 1;\n  text-align: right;\n  margin-right: 10px; /* Add some space between the star rating and button */\n}\n.center {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 35px;\n}\n.user-photo{\n  width: 75%;\n  margin: auto;\n  margin-top: 15px;\n}\n@media (minwidth: 768px) {\n  .bg-header-mobile {\n    display: none;\n  }\n}\n\n@media (maxwidth: 768px) {\n  .bg-header {\n    display: none;\n  }\n   .bg-inter {\n  padding: 100px 30px;\n}\n  .responsive {\n    width: 100%;\n    height: auto;\n  }\n  section {\n    align-items: center;\n    padding: 50px 30px;\n  }\n  .cards {\n    padding-top: 50px; /* Reduce padding on smaller screens */\n  }\n\n  .slick-slider {\n    padding-top: 50px; /* Reduce padding on smaller screens */\n  }\n  .slick-slider .slick-slide {\n    margin-right: 20px; /* Adjust this value to control the space between cards */\n  }\n  .slick-prev,\n  .slick-next {\n    font-size: 16px; /* Decrease arrow size on smaller screens */\n    width: 30px;\n    height: 30px;\n  }\n\n  .btn,\n  .btn-more {\n    font-size: 14px; /* Decrease button font size on smaller screens */\n    padding: 8px 18px !important;\n  }\n  .center{\n    width: 60% !important;\n  }\n}\n.custom-rating {\n  /* Ajoutez vos styles personnalisés ici */\n  /* Par exemple */\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.column {\n  padding: 10px; /* Optional padding for spacing */\n}\n\n.arrowDown{\n  animation: MoveUpDown 1s linear infinite;\n   position: relative;\n   left: 0;\n   bottom: 0;\n }\n\n @media (max-width: 1089px) {\n  .arrowDown{\n    width: 5% !important;\n  }\n  .bg-inter {\n  padding: 100px 30px;\n}\n}\n\n@keyframes MoveUpDown {\n  0%, 100% {\n    bottom: 0;\n  }\n  50% {\n    bottom: 15px;\n  }\n}\n\n.hover14 {\n  position: relative;\n  /*display: inline-block;*/ /* Ensures that the hover effect wraps around the image */\n}\n\n.hover14::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -75%;\n  z-index: 2;\n  display: block;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 100%);\n  transform: skewX(-25deg);\n}\n\n.hover14:hover::before {\n  animation: shine 0.75s forwards;\n}\n\n@keyframes shine {\n  100% {\n    left: 125%;\n  }\n}\n\n@media (max-width: 1090px) {\n  \n  .column {\n    flex: 1 1 100%;\n    /* text-align: center; */\n  }\n  .bg-inter {\n  padding: 100px 30px;\n}\n}\n\n/* Responsive for mobile */\n@media (max-width: 480px) {\n \n  .column {\n    flex: 1 1 100%;\n    padding: 2% 0; /* Additional padding for mobile */\n  }\n\n  .bg-inter {\n  padding: 100px 30px;\n}\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
